module.exports = __webpack_public_path__ + "static/media/galerija_2021 (25).04db2099.jpg";